module.exports = __webpack_public_path__ + "media/images/icon__warning@3x-0d7428b20b11b14a835bcb850acf5eea.png";